import {Component, Inject, OnInit} from '@angular/core';
import {FormGroup, UntypedFormBuilder, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TranslateService} from "@ngx-translate/core";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ClientsService} from "@core/services/backend/common/service/clients.service";
import {Client} from "@core/services/backend/common/interface/clients";

@Component({
    selector: 'vex-clients-create-update',
    templateUrl: './clients-create-update.component.html',
    styleUrls: ['./clients-create-update.component.scss']
})
export class ClientsCreateUpdateComponent implements OnInit {

    form: FormGroup;
    mode: 'create' | 'update' = 'create';

    constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
                private dialogRef: MatDialogRef<ClientsCreateUpdateComponent>,
                private fb: UntypedFormBuilder,
                private translateService: TranslateService,
                private snackbar: MatSnackBar,
                private clients: ClientsService) {
    }

    ngOnInit() {
        if (this.defaults) {
            this.mode = 'update';
        } else {
            this.defaults = {} as Client;
        }

        this.form = this.fb.group({
            id: [this.defaults.id || null],
            name: [this.defaults.name || '', [Validators.required]],
            active: [this.defaults.active !== false]
        });
    }

    save() {
        if (this.mode === 'create') {
            this.create();
        } else if (this.mode === 'update') {
            this.update();
        }
    }

    create() {
        const client = this.form.value;
        delete client.id;
        this.clients.create(client).subscribe({
            next: (result) => {
                this.snackbar.open('Cliente creado correctamente', '', {
                    duration: 3000
                });
                this.dialogRef.close(result);
            },
            error: (err) => {
                this.snackbar.open('Error al crear el cliente', '', {
                    duration: 3000
                });
            }
        });
    }

    update() {
        const client = this.form.value;
        this.clients.update(client).subscribe({
            next: (result) => {
                this.snackbar.open('Cliente actualizado correctamente', '', {
                    duration: 3000
                });
                this.dialogRef.close(result);
            },
            error: (err) => {
                this.snackbar.open('Error al actualizar el cliente', '', {
                    duration: 3000
                });
            }
        });
    }

    cancel() {
        this.dialogRef.close();
    }
}

